// Centralised mascot art URLs (transparent PNGs from backend /api/art)
import { BACKEND_URL } from './api';

const BASE = BACKEND_URL;
export const ART = {
  hero: `${BASE}/api/art/mascot-hero.png`,
  wave: `${BASE}/api/art/mascot-wave.png`,
  tarot: `${BASE}/api/art/mascot-tarot.png`,
  coffee: `${BASE}/api/art/mascot-coffee.png`,
  map: `${BASE}/api/art/mascot-map.png`,
  sleepy: `${BASE}/api/art/mascot-sleepy.png`,
  confused: `${BASE}/api/art/mascot-confused.png`,
  party: `${BASE}/api/art/mascot-party.png`,
};
